// Splits clipboard content pasted from spreadsheets (Excel, Google Sheets) into
// individual cells: by line breaks (rows) and tabs (columns).
const CLIPBOARD_DELIMITER = /\r?\n|\t/;

export const hasClipboardDelimiter = (raw: string): boolean => CLIPBOARD_DELIMITER.test(raw);

export const parseClipboard = (raw: string, isNumber?: boolean): string[] => {
    const items = raw
        .split(CLIPBOARD_DELIMITER)
        .map((s) => s.trim())
        .filter(Boolean);

    if (isNumber) {
        return items.map((s) => s.replace(/[^0-9.]/g, "")).filter(Boolean);
    }

    return items;
};
